import Checkout from 'pages/campaign/SellPage/Checkout';
import React from 'react'

const UsernameLinkOrPageNotFound: React.FC<{ [label: string]: any }> = (props: any) => {

    const url = window.location.href.toLowerCase();
    const urlItems = url.split('/')
    const subdomain = urlItems[2].split('.')[0]
    const username = (urlItems[3] !== undefined && urlItems[3] !== null && urlItems[3] !== '') ? urlItems[3] : undefined

    if (subdomain !== 'app' && subdomain !== 'localhost:3000' && subdomain !== 'test') {
        return <Checkout subdomain={subdomain} username={username} />
    }

    return <div>
        <div style={{ height: 'auto' }}>
            <div className='container'>
                <div className="div_holder_2">
                    <div
                        className="div_holder_4"
                        style={{
                            color: "#242d51"
                        }}
                    >
                        <p />
                        <div
                            className="col-sm-12 pt-2"
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                paddingLeft: '10%', paddingRight: '10%'
                            }}
                        >
                            <div
                                className="row pt-3"
                                style={{ maxWidth: "800px", }}
                            >
                                <div className="col text-center">
                                    <div>
                                        <h6 style={{ textAlign: 'center' }} className="sexyBlack">
                                            <strong>
                                                Page not found<br />
                                                <small>Contact info@isotopeticketing.com for more info.</small><br /><br />
                                            </strong>
                                        </h6>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default UsernameLinkOrPageNotFound;


// WEBPACK FOOTER //
// ./src/components/app/PageNotFound.tsx